// components/StatCard.jsx
import React from 'react';

class ProjectCard extends React.Component {
  render() {
    const {
      icon: Icon,
      className,
      title,
      value,

      // color = 'green', // or 'red', 'yellow', etc.
    } = this.props;

    return (
      <div className={`project-card action`}>
        <div className="project-card-body">
          <div className={`project-card-icon ${className}`}>
            <Icon size={24} />
          </div>
          <div className="project-card-text">
            <div className="project-header">{title}</div>
            <div className="project-value">{value}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectCard;
